module.exports = {
  templateUrl: 'signin/components/forgot-password/forgot-password.html',
  controller: class ForgotPassword {

    static $inject = [
      '$state',
      '$timeout',
      'RegistrationService',
      'PatientAppContextService',
    ];

    constructor($state, $timeout, RegistrationService, PatientAppContextService) {
      this.$state = $state;
      this.$timeout = $timeout;
      this.RegistrationService = RegistrationService;
      this.PatientAppContextService = PatientAppContextService;
    }

    $onInit() {
      this.RegistrationService.states.forgotPassword.emailSent = false;
      this.clinic = this.PatientAppContextService.context.group;
      setTimeout(() => {
        this.clearErrors();
      });
    }

    onKeyDown() {
      if (this.states().notFound && this.form.$invalid) {
        this.RegistrationService.states.forgotPassword.notFound = false;
        this.form.email.$setValidity('dont_exist', true);
      }
    }

    hasErrors(ngModel) {
      return this.RegistrationService.hasErrors(ngModel);
    }

    states() {
      return this.RegistrationService.states.forgotPassword;
    }

    key() {
      return this.RegistrationService.key;
    }

    submit() {
      this.saving = true;
      // timeout ensures that the loading message won't annoyingly flicker
      this.$timeout(() => {
        this.sendEmail();
      }, 250);
    }

    sendEmail() {
      this.RegistrationService.resetPassword({
        email: this.email,
        groupId: this.clinic.id,
      }).then(this.emailSent, this.emailFailed);
    }

    emailSent = () => {
      this.saving = false;
      this.RegistrationService.states.forgotPassword.emailSent = true;
      return true;
    };

    emailFailed = () => {
      this.saving = false;
      this.RegistrationService.states.forgotPassword.notFound = true;
      this.form.email.$setValidity('dont_exist', false);
    };

    canSubmit() {
      return this.RegistrationService.canSubmit(this.form) && this.form.$valid;
    }

    login() {
      this.$state.go('login', this.$state.params);
    }

    clearErrors() {
      if (this.form.email.$invalid) {
        const formErrors = Object.keys(this.form.$error);
        formErrors.forEach((error) => {
          if (this.form.email.value) {
            this.form.email.$setValidity(error, true);
          } else {
            this.form.email.$setValidity(error, false);
          }
        });
      }

      if (this.states().notFound) {
        this.RegistrationService.states.forgotPassword.notFound = false;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./signin/components/forgot-password/forgot-password.js